<template>
  <div class="map">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.358648925748!2d139.65929725107026!3d35.668170038197886!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f3121b67cc23%3A0x142da890cab7d079!2sTokyoDex!5e0!3m2!1sen!2suk!4v1680077906600!5m2!1sen!2suk"
            title="TokyoDex Google map"
            width="600"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
    </iframe>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
@use '@/assets/sass/variables.scss' as v;
.map {
  border: 0;
  width: 100%;
  margin: 0 0 1rem 0;
	@include v.respond-to('small') {
		margin: 0 0 3rem 0;
	}
  iframe {
    border: 0;
    width: 100%;
  }
}
</style>
